import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export default function IndividualDeliverModal({ openDialog, handleOnCloseClicked, selectedCount, handleOnSendClicked }) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  const onCloseClicked = () => {
    setOpen(false);
    handleOnCloseClicked();
  };

  const onSendClicked = () => {
    handleOnSendClicked();
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseClicked}
        aria-labelledby="modal-individual-deliver-title"
        aria-describedby="modal-individual-deliver-description"
        className="mx-4 md:mx-0"
      >
        <Box sx={style} className={'px-4 py-6 rounded-[16px] w-full md:w-2/6'}>
          <Typography id="modal-individual-deliver-title" variant="h6" component="h2" className="text-center">
            選択した検体を発送しますか
          </Typography>
          <Typography id="modal-individual-deliver-description" sx={{ my: 4 }} align="center">
            検体  {selectedCount}  個
          </Typography>
          <div className="w-[180px] mx-auto">
            <button
              onClick={onSendClicked}
              type="button"
              className="button-size bg-blue-btn-primary mr-4 lg:mr-6"
            >
              発送確定
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
